<script lang="ts">
  export default {
    name: 'ExportList',
  };
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { computed, onMounted, onUnmounted, inject, ref } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import {FileType} from '@/utilities/tower/v2/Download';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');
const exportOptionsRef = ref<HTMLDivElement | null>(null);

// ----------
// computed
// ----------
const exportListShowing = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.showExportOptions;
});

onMounted(() => {
  document.addEventListener('click', handleMouseClick);
});

onUnmounted(() => {
  document.removeEventListener('click', handleMouseClick);
});

// ----------
// handlers
// ----------

function handleDownload(fileType: string): void {
  store?.commit(StoreMutationType.TOWER_EXPORT_FILE_TYPE, fileType);
  store?.commit(StoreMutationType.SHOW_TOWER_EXPORT_OPTIONS, false);
}

function handleMouseClick(e: MouseEvent): void {
  if (exportOptionsRef.value && !exportOptionsRef.value.contains(e.target as Node)) {
    store?.commit(StoreMutationType.SHOW_TOWER_EXPORT_OPTIONS, false);
  }
}
</script>

<template>
  <div ref="exportOptionsRef" v-show="exportListShowing">
    <ul class="export-menu tw:pointer-events-auto tw:opacity-95 tw:list-none tw:py-2 tw:px-0 tw:rounded tw:shadow-lg">
      <li>
        <button class="export-menu-option tw:w-full tw:text-left tw:font-bold tw:py-2 tw:px-4 tw:transition-colors tw:duration-75" @click="handleDownload(FileType.SVG)">
          Export as SVG
        </button>
      </li>
      
      <li>
        <button class="export-menu-option tw:w-full tw:text-left tw:font-bold tw:py-2 tw:px-4 tw:transition-colors tw:duration-75" @click="handleDownload(FileType.PNG)">
          Export as PNG
        </button>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.export-menu {
  background-color: var(--tower-v2-context-menu-bg-color);
}

.export-menu-option {
  color: #ced4da;
}

.export-menu-option:hover {
  background-color: var(--tower-v2-context-menu-bg-color-hover);
}
</style>
